(function () {
  var headingSelector = 'h2, h3';
  var madeToOrderText = 'made to order';
  var madeToOrderContent = 'Each wndrfm* piece is made to order in our studio. For this reason, we’re unable to accept returns or exchanges for changes of mind, personal preference, or selections made at checkout. We recommend reviewing the product description, dimensions, color, and other details carefully before placing your order.';

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getPolicyBody() {
    return (
      document.querySelector('.shopify-policy__body') ||
      document.querySelector('#mainContent > div:first-child > div:nth-child(2)')
    );
  }

  function getPolicyHeadings(policyBody) {
    if (!policyBody) return [];
    return Array.prototype.slice.call(policyBody.querySelectorAll(headingSelector));
  }

  function updatePolicyTitle() {
    var policyTitle = document.querySelector('.shopify-policy__title h1, #mainContent > div:first-child > div:first-child h1');

    if (policyTitle && normalizeText(policyTitle.textContent) === 'refund policy') {
      policyTitle.textContent = 'Return and Refund';
    }
  }

  function collectSectionNodes(heading) {
    var nodes = [];
    var currentNode = heading.nextElementSibling;

    while (currentNode && !currentNode.matches(headingSelector)) {
      nodes.push(currentNode);
      currentNode = currentNode.nextElementSibling;
    }

    return nodes;
  }

  function parseRefundPolicySections() {
    var policyBody = getPolicyBody();
    var headings = getPolicyHeadings(policyBody);

    if (!policyBody || headings.length < 2) {
      return null;
    }

    var madeToOrderIndex = headings.findIndex(function (heading) {
      return normalizeText(heading.textContent) === madeToOrderText;
    });

    if (madeToOrderIndex === -1 || madeToOrderIndex === headings.length - 1) {
      return null;
    }

    return {
      policyBody: policyBody,
      staticHeading: headings[madeToOrderIndex],
      staticContent: collectSectionNodes(headings[madeToOrderIndex]),
      accordionSections: headings.slice(madeToOrderIndex + 1).map(function (heading) {
        return {
          heading: heading,
          contentNodes: collectSectionNodes(heading)
        };
      }).filter(function (section) {
        return normalizeText(section.heading.textContent) !== '';
      })
    };
  }

  function preserveStaticSection(parsedPolicy) {
    parsedPolicy.staticHeading.classList.add('policy-static-heading');
    parsedPolicy.staticHeading.dataset.policyAccordionStaticHeading = 'true';

    parsedPolicy.staticContent.forEach(function (node) {
      node.classList.add('policy-static-content');
      node.dataset.policyAccordionStaticContent = 'true';
    });
  }

  function replaceStaticSectionContent(parsedPolicy) {
    var replacementParagraph = document.createElement('p');

    replacementParagraph.textContent = madeToOrderContent;

    parsedPolicy.staticContent.forEach(function (node) {
      node.remove();
    });

    parsedPolicy.staticHeading.insertAdjacentElement('afterend', replacementParagraph);
    parsedPolicy.staticContent = [replacementParagraph];
  }

  function createIcon(className) {
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var horizontalPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    icon.setAttribute('class', className);
    icon.setAttribute('width', '22');
    icon.setAttribute('height', '22');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', 'currentColor');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');

    horizontalPath.setAttribute('fill-rule', 'evenodd');
    horizontalPath.setAttribute('clip-rule', 'evenodd');
    horizontalPath.setAttribute('d', 'M21 13L3 13L3 11L21 11L21 13Z');
    icon.appendChild(horizontalPath);

    if (className.indexOf('accordion__icon--plus') !== -1) {
      var verticalPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      verticalPath.setAttribute('fill-rule', 'evenodd');
      verticalPath.setAttribute('clip-rule', 'evenodd');
      verticalPath.setAttribute('d', 'M11 21L11 3L13 3L13 21L11 21Z');
      icon.appendChild(verticalPath);
    }

    return icon;
  }

  function replaceEmailPlaceholder(section) {
    section.contentNodes.forEach(function (node) {
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      var textNode = walker.nextNode();

      while (textNode) {
        textNode.nodeValue = textNode.nodeValue.replace(/\[email address\]/g, 'studio@wndrform.com');
        textNode = walker.nextNode();
      }
    });
  }

  function mergeCancellationsParagraphs(section) {
    if (normalizeText(section.heading.textContent) !== 'cancellations') {
      return;
    }

    var paragraphs = section.contentNodes.filter(function (node) {
      return node.matches && node.matches('p');
    });

    if (paragraphs.length < 2) {
      return;
    }

    var firstParagraph = paragraphs[0];

    paragraphs.slice(1).forEach(function (paragraph) {
      if (firstParagraph.textContent.trim() !== '' && paragraph.textContent.trim() !== '') {
        firstParagraph.appendChild(document.createTextNode(' '));
      }

      while (paragraph.firstChild) {
        firstParagraph.appendChild(paragraph.firstChild);
      }

      section.contentNodes = section.contentNodes.filter(function (node) {
        return node !== paragraph;
      });

      paragraph.remove();
    });
  }

  function mergeParagraphIntoPreviousByText(section, paragraphText) {
    var paragraphs = section.contentNodes.filter(function (node) {
      return node.matches && node.matches('p');
    });
    var targetParagraph = paragraphs.find(function (paragraph) {
      return normalizeText(paragraph.textContent).indexOf(normalizeText(paragraphText)) !== -1;
    });
    var targetIndex = paragraphs.indexOf(targetParagraph);
    var previousParagraph = targetIndex > 0 ? paragraphs[targetIndex - 1] : null;

    if (!targetParagraph || !previousParagraph) {
      return;
    }

    if (previousParagraph.textContent.trim() !== '' && targetParagraph.textContent.trim() !== '') {
      previousParagraph.appendChild(document.createTextNode(' '));
    }

    while (targetParagraph.firstChild) {
      previousParagraph.appendChild(targetParagraph.firstChild);
    }

    section.contentNodes = section.contentNodes.filter(function (node) {
      return node !== targetParagraph;
    });

    targetParagraph.remove();
  }

  function createAccordionItem(section, index) {
    var item = document.createElement('div');
    var header = document.createElement('div');
    var button = document.createElement('button');
    var label = document.createElement('span');
    var toggle = document.createElement('span');
    var toggleButton = document.createElement('span');
    var content = document.createElement('div');
    var headingText = section.heading.textContent.trim();
    var safeIndex = index + 1;
    var titleId = 'policy-accordion-title-' + safeIndex;
    var contentId = 'policy-accordion-content-' + safeIndex;

    item.className = 'policy-accordion__item accordion__item js-accordion-item';
    header.className = 'accordion__header';

    button.className = 'btn-plain w-100 js-accordion-trigger d-flex middle-xs p-relative p-zero c-pointer gap-12';
    button.id = titleId;
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', contentId);

    label.className = 'h5 m-zero flex-1 ta-left';
    label.textContent = headingText;

    toggle.className = 'accordion__toggle zi-1 d-flex';
    toggleButton.className = 'zi-1 btn btn-small btn-icon';
    toggleButton.appendChild(createIcon('accordion__icon--plus p-absolute'));
    toggleButton.appendChild(createIcon('accordion__icon--minus p-absolute'));
    toggle.appendChild(toggleButton);

    content.className = 'policy-accordion__content js-accordion-content accordion-content mb-0 rte';
    content.id = contentId;
    content.setAttribute('role', 'region');
    content.setAttribute('aria-describedby', titleId);
    content.setAttribute('tabindex', '-1');
    content.style.maxHeight = '0';

    replaceEmailPlaceholder(section);
    mergeCancellationsParagraphs(section);
    mergeParagraphIntoPreviousByText(
      section,
      'Once we review the details, we may offer a replacement or refund, depending on the circumstances. Please do not return an item before contacting us.'
    );
    section.heading.remove();
    section.contentNodes.forEach(function (node) {
      content.appendChild(node);
    });

    button.appendChild(label);
    button.appendChild(toggle);
    header.appendChild(button);
    item.appendChild(header);
    item.appendChild(content);

    return item;
  }

  function togglePolicyAccordionItem(trigger, isOpen) {
    var content = document.getElementById(trigger.getAttribute('aria-controls'));

    if (!content) {
      return;
    }

    trigger.setAttribute('aria-expanded', String(isOpen));
    trigger.classList.toggle('open', isOpen);
    content.classList.toggle('open', isOpen);
    content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
  }

  function bindPolicyAccordion(accordion) {
    accordion.querySelectorAll('.js-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        togglePolicyAccordionItem(trigger, trigger.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function transformAccordionSections(parsedPolicy) {
    if (parsedPolicy.policyBody.dataset.policyAccordionTransformed === 'true') {
      return;
    }

    var accordion = document.createElement('div');
    var insertAfter = parsedPolicy.staticContent.length > 0
      ? parsedPolicy.staticContent[parsedPolicy.staticContent.length - 1]
      : parsedPolicy.staticHeading;

    accordion.className = 'policy-accordion';

    parsedPolicy.accordionSections.forEach(function (section, index) {
      accordion.appendChild(createAccordionItem(section, index));
    });

    insertAfter.insertAdjacentElement('afterend', accordion);
    bindPolicyAccordion(accordion);
    parsedPolicy.policyBody.dataset.policyAccordionTransformed = 'true';
  }

  function initPolicyAccordionParser() {
    updatePolicyTitle();

    var parsedPolicy = parseRefundPolicySections();

    if (!parsedPolicy || parsedPolicy.accordionSections.length === 0) {
      return;
    }

    preserveStaticSection(parsedPolicy);
    replaceStaticSectionContent(parsedPolicy);
    transformAccordionSections(parsedPolicy);
    parsedPolicy.policyBody.dataset.policyAccordionReady = 'true';
  }

  window.WndrfmPolicyAccordion = {
    getPolicyBody: getPolicyBody,
    getPolicyHeadings: getPolicyHeadings,
    updatePolicyTitle: updatePolicyTitle,
    parseRefundPolicySections: parseRefundPolicySections,
    preserveStaticSection: preserveStaticSection,
    replaceStaticSectionContent: replaceStaticSectionContent,
    transformAccordionSections: transformAccordionSections,
    bindPolicyAccordion: bindPolicyAccordion
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyAccordionParser);
  } else {
    initPolicyAccordionParser();
  }
})();
